<template>
  <div
    class="pt-5 m-3 page-header align-items-start min-vh-50 pb-10 border-radius-lg header-bg"
    :style="{
      backgroundImage: 'url(' + require('@/assets/img/auth/mi-socio.jpg') + ')',
    }"
  >
    <div class="light-effect"></div>
    <span class="mask bg-gradient-dark opacity-5"></span>

    <div class="container">
      <div class="row justify-content-center">
        <div class="mx-auto text-center col-lg-5 mt-4">
          <!-- 🐱 常設ロゴ -->
          <img
            :src="logoSrc"
            :class="['main-logo', { 'logo-entry': isAnimating }]"
            @animationend="onAnimationEnd"
            alt="Logo"
          />
          <p class="text-white text-lead mt-2">
            AIと遊ぼう、新しい世界へ一歩！
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- ===== ログインカード ===== -->
  <div class="container animate-fade-in">
    <div class="row mt-lg-n10 mt-md-n11 mt-n10 justify-content-center">
      <div class="mx-auto col-xl-5 col-lg-5 col-md-7">
        <div class="card z-index-0">
          <!-- ===== お知らせ欄 ===== -->
          <div v-if="true" class="card-header border-bottom pb-2">
            <h6 class="mb-2">
              📢 お知らせ<br />2026年10月16日 .... Ver2.2 をリリースしました 🎉
            </h6>
            <ul class="announcement">
              <li v-for="(notice, index) in notices" :key="index">
                {{ notice }}
              </li>
            </ul>
          </div>

          <!-- ===== ログイン ===== -->
          <div class="text-center card-header border-bottom pb-2">
            <h5>ログイン画面</h5>

            <p
              v-if="showExpiredMessage"
              class="text-start text-sm text-danger text-bolder mb-2"
            >
              ※ セッションの有効期限が切れました。再度ログインしてください。
            </p>
            <!--
            <p
              v-if="showLoginError"
              class="text-start text-sm text-danger text-bolder mb-2"
            >
              ※ ログインIDまたはパスワードが正しくありません。
            </p>
            -->
          </div>

          <div class="card-body">
            <p v-if="false" class="text-start text-sm">
              ※ 会社のアカウント（EntraID）でログインします。<br />
              ※ mi社員番号@benichu.com を入力してください。
            </p>
            <div v-if="true" class="mb-3">
              <input
                class="form-control form-control-default mb-3"
                name="email"
                placeholder="ログインIDを入力してください"
                v-model="login.email"
                @keyup.enter="OnLogin"
              />
            </div>
            <div v-if="true" class="mb-3">
              <input
                class="form-control form-control-default"
                type="password"
                placeholder="パスワードを入力してください"
                v-model="login.password"
                @keyup.enter="OnLogin"
              />
            </div>
            <div class="mb-3">
              <a
                v-if="false"
                :href="saml2LoginUrl"
                class="btn mb-0 bg-gradient-warning btn-md w-100"
                style="text-transform: none"
              >
                Microsoft Azure からログイン
              </a>
              <soft-button
                v-if="true"
                class="mb-4"
                variant="gradient"
                color="warning"
                full-width
                @click="OnLogin"
                style="text-transform: none"
              >
                検証アカウントでログイン
              </soft-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer />
</template>

<script>
import AppFooter from '@/components/PageLayout/Auth/Footer.vue'
import useVuelidate from '@vuelidate/core'
import HTTPService from '../services/HTTPService'
import { required, email } from '@vuelidate/validators'
import SoftButton from '@/components/SoftButton.vue'
import { useAuthStore } from '@/store/auth'

export default {
  name: 'Login',
  components: {
    SoftButton,
    AppFooter,
  },
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      login: {
        email: '',
        password: '',
      },
      status: '',
      showWarning: false,
      showFault: false,
      statusFaultMessage: '',
      faultMessage: '',
      error: false,
      showExpiredMessage: false,
      showLoginError: false,
      saml2LoginUrl: process.env.VUE_APP_SAML2_LOGIN_URL,
      isAnimating: false,
      logoSrc: require('@/assets/img/auth/MI-chao_logo_top.png'),
      notices: [
        'AIモデルを最新版に更新しました。より賢く、快適にご利用いただけます',
        '高性能な「Claude Opus 5.5」、性能と速度のバランスに優れた「Claude Sonnet 5.5」、高速・低コストな「Claude Haiku 5.5」を選べるようになりました',
      ],
    }
  },
  validations() {
    return {
      login: {
        email: { required, email },
        password: { required },
      },
    }
  },
  methods: {
    async OnLogin() {
      if (this.v$.$invalid) {
        this.error = true
      } else {
        this.error = false
        var response = await HTTPService.login(
          this.login.email,
          this.login.password,
        )
        if (response.data.token) {
          //if (this.$refs.stayLoggedIn.checked)
          //  localStorage.setItem('token', response.data.token)
          //else localStorage.setItem('token', response.data.token)

          //localStorage.setItem('token', response.data.token)
          const auth = useAuthStore()
          auth.setToken(response.data.token)

          // make an async call to upload to ping the AI server running the upload method.
          // setTimeout(() => {
          //   HTTPService.upload(null, null).then((response) => {
          //     console.log('finished dummy call')
          //     console.log(response.data)
          //   })
          // }, 0)
          this.$emit('change-active-component', {
            component: 'ChatbotDashboard',
          })
          this.$store.commit('updateTriggerPolling', true)

          this.$router.push('/service/main-chat')
          //console.log('finished login call')
        } else if (response.data.message) {
          if (response.data.message == 'User login unsuccessful') {
            //this.WrongPassword()
            this.showLoginError = true
          } else {
            this.showWarning = true
            this.$refs.loginTemplate.classList.add('bg-blur')
          }
        } else {
          this.error = true
          this.WrongPassword()
        }
      }
    },
    WrongPassword() {
      this.showFault = true
      this.statusFaultMessage = 'Login Failed'
      this.faultMessage = 'Incorrect email address or password'
      this.$refs.loginTemplate.classList.add('bg-blur')
    },
    OnRegister() {
      this.$emit('change-active-component', {
        component: 'Register',
      })
      // this.$router.push({ name: 'Register' })
    },
    OnReset() {
      //console.log('reset')
      // this.$router.push({ name: 'ResetPassword' })
      this.$emit('change-active-component', {
        component: 'ResetPassword',
      })
    },
    onCancel() {
      this.$refs.loginTemplate.classList.remove('bg-blur')
      this.showWarning = false
      this.showFault = false
    },
    onResend() {
      let body = {
        email: this.login.email,
        password: this.login.password,
      }
      HTTPService.sendconfirmemail(body).then(() => {
        this.onCancel()
      })
    },
    onAnimationEnd() {
      // アニメーション終了後に通常ロゴへ戻す
      this.logoSrc = require('@/assets/img/auth/MI-chao_logo_top.png')
      this.isAnimating = false
    },
  },
  mounted() {
    // sessionStorage にフラグがあればメッセージを出す
    if (localStorage.getItem('expired') === 'true') {
      this.showExpiredMessage = true
      // ✅ 1回表示したら削除（再読み込み時に出ないように）
      localStorage.removeItem('expired')
    }
    // 🎯 35%の確率でアニメーション
    if (Math.random() < 0.35) {
      this.isAnimating = true
      // アニメーション中はオレンジロゴ
      this.logoSrc = require('@/assets/img/auth/MI-chao_logo_top_orange.png')
    }
  },
}
</script>
<style scoped>
@keyframes appearFromShadow {
  0% {
    transform: translateX(-50%) scale(1);
    opacity: 0;
    filter: blur(4px);
  }
  60% {
    transform: translateX(10%) scale(1);
    opacity: 1;
    filter: blur(0);
  }
  100% {
    transform: translateX(0%) scale(1);
    opacity: 1;
  }
}

.logo-appear-shadow {
  animation: appearFromShadow 0.5s ease-out 0.8s both;
}
/* 背景を少し柔らかく */
.header-bg {
  background-size: cover;
  background-position: center;
  position: relative;
}

/* ロゴ */
.main-logo {
  width: 38%;
}

/* 初期状態：画面の完全左外に配置 */
.logo-entry {
  opacity: 0;
  transform: translateX(-120vw) rotate(-10deg);

  /* 2秒待ってから1.8秒で登場 */
  animation: logoSpinIn 2.9s ease-out forwards;
  animation-delay: 0.8s;
}

/* くるくる回転しながら登場 */
@keyframes logoSpinIn {
  0% {
    opacity: 0;
    transform: translateX(-120vw) rotate(0deg) scale(0.8);
  }

  40% {
    opacity: 1;
    transform: translateX(-40vw) rotate(360deg) scale(1);
  }

  70% {
    transform: translateX(10px) rotate(900deg) scale(1.05);
  }

  100% {
    transform: translateX(0) rotate(1080deg) scale(1);
    opacity: 1;
  }
}

/* お知らせ */
.announcement {
  font-size: 0.85rem;
  padding-left: 1rem;
}

.announcement li {
  margin-bottom: 4px;
}

/* ログインボタン */
.login-btn {
  transition: all 0.3s ease;
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}
</style>
